export const Bio = {
    name: "Vinita Kumari Pal",
    roles: [
      "Full Stack Developer",
      "Machine Learning Enthusiast",
      "Web Developer",
      "Programmer",
      "Doodler"
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/dis-ease-20/",
    resume:
      "https://drive.google.com/file/d/1xAlkrSkAfvNxVkNKs_kqakUqzLylME9y/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/vinitapal/",
    // twitter: "https://twitter.com/dumy",
    // insta: "https://www.instagram.com/dummy/",
    // facebook: "https://www.facebook.com/dummy/",
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Redux",
          image:
            "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        },
        {
          name: "Next Js",
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        {
          name: "Material UI",
          image:
            "data:image/png;base64,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",
        }
      ],
    },
    {
      title: "Backend",
      skills: [
        // {
        //   name: "Node Js",
        //   image: "https://nodejs.org/static/images/logo.svg",
        // },
        // {
        //   name: "Express Js",
        //   image:
        //     "data:image/png;base64,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",
        // },
        // {
        //   name: "Graph Ql",
        //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
        // },
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        // {
        //   name: "Postgresql",
        //   image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        // },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        // {
        //   name: "Firebase",
        //   image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        // },
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "XML",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
        },
      ],
    },
    // {
    //   title: "Android",
    //   skills: [
    //     {
    //       name: "Java",
    //       image:
    //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    //     },
    //     // {
    //     //   name: "Kotlin",
    //     //   image:
    //     //     "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
    //     // },
    //     {
    //       name: "XML",
    //       image:
    //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
    //     },
    //     // {
    //     //   name: "Android Studio",
    //     //   image:
    //     //     "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
    //     // },
    //   ],
    // },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://img.icons8.com/?size=100&id=20906&format=png&color=000000",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        // {
        //   name: "Docker",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        // },
        {
          name: "Netlify",
          image:
            "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
        },
        {
          name: "ServiceNow",
          image:
            "https://cdn.icon-icons.com/icons2/2699/PNG/512/servicenow_logo_icon_168835.png",
        },
        {
          name: "Google Cloud",
          image:
            "https://static-00.iconduck.com/assets.00/google-cloud-icon-2048x1646-7admxejz.png",
        }
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://media.glassdoor.com/sqll/3592279/onebanc-technologies-pvt-ltd-squareLogo-1639980406039.png",
      role: "Full Stack Developer",
      company: "OneBanc Technology Pvt. Ltd.",
      date: "Jan 2024 - Oct 2024",
      desc: "Worked with core tech team to build the compnay's product.",
      skills: [
        "Java",
        "HTML",
        "CSS",
        "Javascript",
        "React JS",
        "Mysql",
        "Json",
        "TypeScript",
        "Postman API Testing",
        "Gitlab",
        "XML"
      ],
      doc: "https://drive.google.com/file/d/1zVMbYsRCURGoOU4VL8LdwXuflPUIUlXT/view?usp=sharing",
    },
    {
      id: 0,
      img: "https://logos-world.net/wp-content/uploads/2020/07/Accenture-Logo.png",
      role: "Custom Software Engieering Associate",
      company: "Accenture",
      date: "Oct 2022 - Oct 2023",
      desc: "Worked with Tech team to add functionality in the client website and later also worked as a L2 support Engineer.",
      skills: [
        "ReactJS",
        "HTML",
        "CSS",
        "JavaScript",
        "Mysql",
        "ServiceNow Platfrom",
        "ITSM",
        "Microsoft Excel",
        "SLA Management"
      ],
      doc: "https://drive.google.com/file/d/1IcIQBTcJWXDOB2e8bOknCN5vGWPAe2hg/view?usp=sharing",
    },
    {
      id: 1,
      img: "https://logosandtypes.com/wp-content/uploads/2022/03/cognizant.svg",
      role: "MERN Stack Internship",
      company: "Cognizant",
      date: "March 2022 - August 2022",
      desc: "Build a real-time website with an interactive design and user experience.",
      skills: [
        "ReactJS",
        "Redux",
        "NodeJs",
        "Material UI",
        "HTML",
        "CSS",
        "JavaScript",
        "Github",
        "AWS",
        "MongoDB",
      ],
      doc: "https://drive.google.com/file/d/1voMihbMgOFSI4_uZqqK8dHEGoQrcneEI/view?usp=sharing",
    },
    {
      id: 2,
      img: "https://media.licdn.com/dms/image/v2/C560BAQH2DIKjyNKb7Q/company-logo_200_200/company-logo_200_200/0/1634279392235/verzeo_logo?e=2147483647&v=beta&t=Nh5ZZlAvLbvZn8IoXqCMAYTWTS21H9oBZYHe4o7LzWg",
      role: "Machine Learning with Python",
      company: "Verzeo Pvt. Ltd.",
      date: "June 2020 - August 2020",
      desc: "Worked with large datasets to train and evaluate machine learning models, and applied techniques such as [e.g. Model selection, cross-validation, etc] to optimize model performance.",
      skills: [
       "Python",
       "Numpy",
       "Pandas",
       "Jupyter",
       "Google Collab",
       "CSV",
       "Matplotlib",
       "NLP"
      ],
      doc: "https://drive.google.com/file/d/1rSQAwcSeumyQr1E3AabYuy8zxuZEUilr/view?usp=sharing",
    },
    {
      id: 3,
      img: "https://connect-assets.prosple.com/cdn/ff/MqeQliGrIyXfUhem8oGQ_9srEzqem6oanEklSi2326Y/1630435543/public/styles/scale_and_crop_center_299x168/public/2021-08/Sparks%20Logo.png?itok=H2-W8ow_",
      role: "Data Science and Business Analyst",
      company: "The Sparks Foundation",
      date: "May 2021 - June 2021",
      desc: "Worked with databases and data warehouses to extract and manipulate data, and applied data modeling techniques to optimize data storage and retrieval.",
      skills: [
        "CSV",
        "Jupyter",
        "Python",
        "NLP",
        "Data Cleaning",
      ],
      doc: "https://drive.google.com/file/d/1rTxpr9PfHnuYcNNhZdremPIoYj-POznF/view?usp=sharing"
    },
    // {
    //   id: 4,
    //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
    //   role: "Android Developer Intern",
    //   company: "Rudraksha Welffare Foundation",
    //   date: "June 2021 - Oct 2021",
    //   desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
    //   skills: [
    //     "Android",
    //     "Java",
    //     "Kotlin",
    //     "XML",
    //     "Node Js",
    //     "Cloud Firestore",
    //     "Firebase",
    //     "Figma",
    //   ],
    //   doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
    // },
  ];
  
  export const education = [  
    {
      id: 0,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlEOUC8r7l4aIdI8LVj-3LYD-3MuSTPGUsQQ&s",
      school: "Shri Shankaracharya Technical Campus, Bhilai",
      date: "June 2018 - June 2022",
      grade: "88.3 %",
      desc: "I completed my undergraduate degree in Computer Science and Engineering from Shri Shankaracharya Technical Campus, Bhilai in 2022, with an aggregate percentage of 88.3%. I was awarded the 'Best Student in Computer Science and Engineering' for my academic excellence.As an E-Cell member, I organized and executed technical events, hackathons, and coding challenges, developing skills in project management, team collaboration, and problem-solving.",
      degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR1vZDeRWB5yhEDWwCfCW5WBUTFk-n4q5M0g&s",
      school: "The Aditya Birla Public School",
      date: "Apr 2017 - Apr 2018",
      grade: "89.8%",
      desc: "I completed my class 12 high school education at The Aditya Birla School, Rawan, where I studied Science with Computer Science.",
      degree: "CBSE(XII), Science with Computer",
    },
    {
      id: 2,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR1vZDeRWB5yhEDWwCfCW5WBUTFk-n4q5M0g&s",
      school: "The Aditya Birla Public School",
      date: "Apr 2015 - Apr 2016",
      grade: "9.8 CGPA",
      desc: "I completed my class 10 education at The Aditya Birla School, Kotputli where I studied all the general subjects",
      degree: "CBSE(X), Science, Maths, S.St",
    },
  ];
  
  export const projects = [
    {
      id: 0,
      title: "OneBanc Technologies - DevPortal Clone",
      date: "Feb 2024 - March 2024",
      description:
        "This project is a UI clone only, and does not include functional cloning of the original website. The focus is on providing a user-friendly interface for API management and customization.The primary objective of this portal is to ease the pain of handling and maintaining API data and updates, which are often documented on paper or in documents. This platform aims to provide a customizable solution that can be tailored to meet the specific requirements of customers/clients.",
      image:
        "https://dev-static.onebanc.ai/picture/landing_landscape.webp",
      tags: [
        "HTML",
        "CSS",
        "Javascript",
        "React.js",
        "Gitlab",
        "CSV"
      ],
      category: "web app",
      github: "https://github.com/Dis-ease-20/OneBanc-Website-Clone",
      webapp: "https://dis-ease-20.github.io/OneBanc-Website-Clone/home",
    },
    {
      id: 1,
      title: "Youtube Lite",
      date: "Nov 2023 - Dec 2023",
      description:
        "Implemented YouTube clone app using HTML, CSS, and JavaScript for UI, Express.js and Node.js for back-end, and MongoDB for database management. Integrated React.js for rendering components and AWS S3 for cloud storage and video uploading",
      image:
        "https://preview.redd.it/youtube-homepage-is-back-v0-i8aw9ix1lc3c1.png?width=1080&crop=smart&auto=webp&s=a1c52e46117125b069454c98197605c83cfe2984",
      tags: [
        "React Js",
        "MongoDb",
        "Material UI",
        "HTML",
        "CSS",
        "Javadcript",
        "Next Js",
        "Github",
        "npm",
        "Tailwind css"
      ],
      category: "web app",
      github: "https://github.com/Dis-ease-20/youtube_lite",
      webapp: "https://vinita-youtube-clone.netlify.app/",
    },
    {
      id: 2,
      title: "Password Generator",
      date: "June 2024 - July 2024",
      description:
        "This is Password Generator that is customizable as per the need and Requirement. It can generate password as per the length, char, integer needed in password to make it more complex",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCyn6hHu6NjYQpKQXyxfNAsPpz0h-3RwWRnA&s",
      tags: ["HTML", "CSS","Javascript", "ReactJS","CSV","Vite"],
      category: "web app",
      github: "https://github.com/Dis-ease-20/React-Learning/tree/main/5_PasswordGenerator",
      webapp: "https://github.com/Dis-ease-20/React-Learning/tree/main/5_PasswordGenerator",
    },
    {
      id: 3,
      title: "Currency Converter",
      date: "Jun 2023 - Jul 2023",
      description:
        "This is project is aim tyo convert the given currency to desired currency using the API dynamically.",
      image:
        "https://mir-s3-cdn-cf.behance.net/project_modules/1400/ea0c1f56500611.59b10c0232b80.jpg",
      tags: ["React Js", "JavaScript", "HTML", "CSS", "Vite","Github", "API", "Dynamic JSON"],
      category: "web app",
      github: "https://github.com/Dis-ease-20/React-Learning/tree/main/6_CurrencyConvertner",
      webapp: "https://github.com/Dis-ease-20/React-Learning/tree/main/6_CurrencyConvertner",
    },
    {
      id: 4,
      title: "Spam Clasifier",
      date: "Feb 2022 - March 2022",
      description:
        "machine learning-based spam classifier using Python, Jupyter Notebook, and Natural Language Processing (NLP) techniques to classify emails as spam or legitimate with high accuracy, utilizing libraries such as NLTK, and scikit-learn to preprocess text data and train a robust model.",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBsqq-19T_e9lemWI8X5HKujw18br05Sdtqw&s",
      tags: ["Jupyter","Python", "CSV","NLP","Pandas","scikit"],
      category: "machine learning",
      github: "https://github.com/Dis-ease-20/Spam-Classifier",
      webapp: "https://github.com/Dis-ease-20/Spam-Classifier",
    },
    {
      id: 5,
      title: "Egg Catcher Game",
      date: "Oct 2021 - Dec 2021",
      description:
        "Designed and developed an interactive egg catcher game using Python, leveraging three nested loops to manage egg creation, catching, and movement. Utilized itertools for dynamic color changes, random for randomized egg spawning, and Tkinter for animations, creating an engaging and immersive gaming experience.",
      image:
        "https://i0.wp.com/thecleverprogrammer.com/wp-content/uploads/2021/04/Picture1.png?resize=627%2C340&ssl=1",
      tags: ["Jupyter","Python", "TK", "Canvas","Tkinter"],
      category: "machine learning",
      github: "https://github.com/Dis-ease-20/Egg-catcher-game",
      webapp: "https://github.com/Dis-ease-20/Egg-catcher-game",
    },
    {
      id: 6,
      title: "Calculator",
      date: "June 2021 - Aug 2021",
      description:
        "A Basic Calculator that can perform functionality such as addition, deletion, substraction and division. This also have the feature to switch for both light and dark mode with appealing UI",
      image:
        "https://i.pinimg.com/originals/62/0f/ea/620fea3a0644cea4b3599374aeb72255.jpg",
      tags: ["React Js", "HTML", "CSS", "Javascript", "Github", "Version Control"],
      category: "web app",
      github: "https://github.com/Dis-ease-20/Basic_Calculator",
      webapp: "https://calculatorbyvinita.netlify.app/",
    },
    {
      id: 7,
      title: "Word Length Calculator",
      date: "Dec 2020 - Jan 2021",
      description:
        "This project is called word length calculator thaat calculate the length of the paragraph or string that is given as input",
      image:
        "https://repository-images.githubusercontent.com/210970246/7aec2a00-dfd0-11e9-9cdf-118f4f6487e1",
      tags: ["HTML","CSS", " JavaScript","Github"],
      category: "web app",
      github: "https://github.com/Dis-ease-20/Word_length_calculator",
      webapp: "https://dis-ease-20.github.io/Word_length_calculator/",
    },
  ];
  
  export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
  ];